import { getAction, postAction, putAction, deleteAction, downFile } from '@api/manage'

// 导出月报 Word（GET，返回 docx 文件流）
export const exportMonthReportWord = (params) =>
  downFile(`/emotionalReport/exportMonthReportWord`, params)

// 获取情绪月报相关参数
export const querySchoolEmotionMoodTrend = (params) =>
  getAction(`emotionalReport/querySchoolEmotionMoodTrend`, params)


// 情绪指数分析-全校情绪指数走势
export const schoolMoodTrend = (params) => getAction(`/statistic/schoolMoodTrend`, params)

// 情绪指数分析-全校关指数走势
export const queryAllGradeEmotionByTime = (params) =>
  getAction(`/emotionalReport/queryAllGradeEmotionByTime`, params)

// 查询年级情绪本月和上月平均值
export const queryCareStudentAvgEmotionByTime = (params) =>
  getAction(`/emotionalReport/queryCareStudentAvgEmotionByTime`, params)

// 查询年级情绪本月和上月平均值
export const queryGradeAvgEmotionByTime = (params) =>
  getAction(`/emotionalReport/queryGradeAvgEmotionByTime`, params)

// 查询全年级情绪当月与上月对比上升前三
export const queryClassEmotionUpTopThree = (params) =>
  getAction(`/emotionalReport/queryClassEmotionUpTopThree`, params)

// 查询全年级情绪当月与上月对比下降前三
export const queryClassEmotionDownTopThree = (params) =>
  getAction(`/emotionalReport/queryClassEmotionDownTopThree`, params)

// 分页查询三次及以上提醒学生数据
export const queryTwoManyThreeRemindStudentCareList = (params) =>
  getAction(`/emotionalReport/queryTwoManyThreeRemindStudentCareList`, params)

// 处理及时班主任前三
export const queryAllDealClassTopThree = (params) =>
  getAction(`/emotionalReport/queryAllDealClassTopThree`, params)

// 查询优秀处理班级前三
export const queryExcellentDealClassTopThree = (params) =>
  getAction(`/emotionalReport/queryExcellentDealClassTopThree`, params)

// 根据时间查询心理辅导管理数据
export const getStudentCounselingDataByTime = (params) =>
  getAction(`/emotionalReport/getStudentCounselingDataByTime`, params)

// 有底图未采集、无底图未采集、未采集数据
export const queryStudentsWithoutFaceStatistics = (params) =>
  getAction(`/emotionalReport/queryStudentsWithoutFaceStatistics`, params)

// 获取相机运行情况
export const queryOnlineAndOffline = (params) =>
  getAction(`/gdCamera/queryOnlineAndOffline`, params)

// 获取相机采集数据部分数据
export const queryAvgDayFaceOfStatusAndSchool = (params) =>
  getAction(`/emotionalReport/queryAvgDayFaceOfStatusAndSchool`, params)

// 获取低活跃度学生数量
export const getMoodContinuedLowModelCount = (params) =>
  getAction(`/emotionalReport/getMoodContinuedLowModelCount`, params)

// 全校提醒人次（每周提醒/关怀人数 + 趋势分析）
export const getSchoolWarningTrend = (params) =>
  getAction(`/emotionalReport/getSchoolWarningTrend`, params)

// 全校情绪健康特征分析（年级特征 + 全校 top3 原因）
export const getSchoolFeatureAnalysis = (params) =>
  getAction(`/emotionalReport/getSchoolFeatureAnalysis`, params)

// 情绪总览（全校情绪指数 / 较上月变化 / 情绪指数最高班级 top3）
export const getEmotionOverview = (params) =>
  getAction(`/emotionalReport/getEmotionOverview`, params)

// 关怀详情（提醒人数 / 关怀率 / 各年级关怀率 / 各原因占比）
export const getCareDetails = (params) => getAction(`/emotionalReport/getCareDetails`, params)

// 教师管理（提醒人数 / 关怀率 / 各年级关怀率 / 提醒趋势）
export const getTeacherDetail = (params) => getAction(`/emotionalReport/getTeacherDetail`, params)

// 各年级情绪指数最高的三个班级
export const getTop3ClassesByEmotion = (params) =>
  getAction(`/emotionalReport/getTop3ClassesByEmotion`, params)

// 各年级情绪指数最低的三个班级
export const getBottom3EmotionClassesPerGrade = (params) =>
  getAction(`/emotionalReport/getBottom3EmotionClassesPerGrade`, params)

// 年级情绪趋势排名
export const getGradeEmotionTrendRanking = (params) =>
  getAction(`/emotionalReport/getGradeEmotionTrendRanking`, params)
